import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css'
import { BrandingProvider } from './context/branding-context';
import App from './App';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrandingProvider>
            <App />
        </BrandingProvider>
    </StrictMode>
);